<script>
import GeolacationPicker from "@/components/warehouse/GeolacationPicker.vue";

const navigationData = {
  warehouseName: null,
  warehouseId: null,
  latitude: null,
  longitude: null,
};
export default {
  name: "NavigationModal",
  components: { GeolacationPicker },
  data() {
    return {
      dialog: false,
      navigationData: {
        ...navigationData,
      },
    };
  },
  methods: {
    open(options) {
      this.dialog = true;
      this.navigationData = {
        ...navigationData,
        ...options,
      };
    },
    showGoogleMap(latitude, longitude) {
      const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

      window.open(mapUrl, "_blank");
    },
  },
};
</script>

<template>
  <v-dialog width="500px" v-model="dialog">
    <v-card class="d-flex flex-column align-center" style="padding: 20px">
      <v-card-title class="title">{{ $t("navModalTitle") }}</v-card-title>
      <v-card-subtitle class="subtitle">{{
        $t("navModalDescription")
      }}</v-card-subtitle>
      <div class="location_container">
        <geolacation-picker
          w="100%"
          h="400px"
          :disabled="true"
          :lat="this.navigationData.latitude"
          :lng="this.navigationData.longitude"
          :waitModal="true"
        />
      </div>
      <v-btn
        @click.stop="
          showGoogleMap(navigationData.latitude, navigationData.longitude)
        "
        width="100%"
        class="mt-3"
        color="grey"
        >{{ $t("navModalBtn") }}</v-btn
      >
    </v-card>
  </v-dialog>
</template>

<style scoped>
.location_container {
  width: 400px;
}

@media screen and (max-width: 420px) {
  .location_container {
    width: 250px;
  }
  .v-card__title.title {
    font-size: 14px !important;
  }

  .subtitle {
    font-size: 11px;
  }
}
@media screen and (max-width: 220px) {
  .location_container {
    width: 180px;
  }
}
</style>
